import SignInForm from '@/components/auth/SignInForm'
import SignUpForm from '@/components/auth/SignUpForm'
import { AuthDialogType, switchAuthDialog } from '@/store/slices/ui-state.slice'
import { RootState } from '@/store/store'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import SendPasswordResetForm from '@/components/auth/SendPasswordResetForm'
import { kDefaultLogoPath } from '@/constants/constants-ui'

type InviteAuthProps = {
  defaultEmail?: string
  /** Called when the user creates a new account (sign up) rather than signing in to an existing one. */
  onSignUp?: () => void
}

export default function InviteAuth(props: InviteAuthProps) {
  const { defaultEmail, onSignUp } = props

  // Watch global UI state
  const { authDialogType } = useAppSelector((state: RootState) => state.uiState)

  const dispatch = useAppDispatch()

  return (
    <div className={'flex-grow flex flex-col justify-center items-center lg:min-h-screen py-5'}>
      <img className="mx-auto w-[200px] mb-4" src={kDefaultLogoPath} alt="Paxton" />
      <h1 className={'mb-4 text-center text-xl font-bold tracking-tight text-brand-neutral-900'}>Accept Invitation</h1>
      <div className="relative transform rounded-lg bg-surface-dialog px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:w-full sm:max-w-md sm:p-6">
        {authDialogType === AuthDialogType.SIGN_IN && (
          <SignInForm
            switchToSignUp={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_UP))}
            switchToForgotPassword={() => {
              dispatch(switchAuthDialog(AuthDialogType.FORGOT_PASSWORD))
            }}
            onSuccess={() => null}
            defaultEmail={defaultEmail}
          />
        )}
        {authDialogType === AuthDialogType.FORGOT_PASSWORD && <SendPasswordResetForm goToSignIn={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_IN))} />}
        {authDialogType === AuthDialogType.SIGN_UP && (
          <SignUpForm
            title="Sign up"
            switchToSignIn={() => dispatch(switchAuthDialog(AuthDialogType.SIGN_IN))}
            onSuccess={() => onSignUp?.()}
            allowReferral={false}
            defaultEmail={defaultEmail}
          />
        )}
      </div>
    </div>
  )
}
